import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { AuthModule } from './auth/auth.module';
import { AppMaterialModule } from './app-material/app-material.module';
import { AppConfigService } from './app-config.service';
import { IconService } from './icons-setting/Icons.service';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MainBoardModule } from './main-board/main-board.module';
import { UsersComponent } from './users/users.component';
import { ConfirmDialogComponent } from './common/confirm-dialog/confirm-dialog.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { CustomSnackbarComponent } from './common/custom-snackbar/custom-snackbar.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { IndvFolderComponent } from './indv-folder/indv-folder.component';
import { FolderDetailDialogComponent } from './folder-detail-dialog/folder-detail-dialog.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SharedModule } from './shared.module';
import { UploadDialogComponent } from './upload-dialog/upload-dialog.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { UploadListModule } from './upload-list/upload-list.module';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { WebViewerFrameComponent } from './web-viewer-frame/web-viewer-frame.component';
import { OAuthModule, OAuthService } from 'angular-oauth2-oidc';
import { ImageZoomDialogComponent } from './common/image-zoom-dialog/image-zoom-dialog.component';
import { ChangePasswordModule } from './change-password/change-password.module';



export const appInitializerFn = (configService: AppConfigService) => {
  return () => configService.loadAppConfig();
};
export const oauthInitializerFn = (oauthService: OAuthService, appConfig: AppConfigService) => {
  // return  () => {
  //   oauthService.configure(authConfig);
  //   return oauthService.loadDiscoveryDocumentAndTryLogin();
  // }

  return async () => {
    // Wait until config is loaded
    if (!appConfig?.config) {
      await appConfig?.loadAppConfig();
      if (!appConfig.config.isGuestLoginEnabled)
        return;
    }
    const authConfig = {
      issuer: appConfig.config?.ssoConfig?.issuer,
      redirectUri: appConfig.config?.ssoConfig?.redirectUri,
      logoutUrl: appConfig.config?.ssoConfig?.postLogoutRedirectUri,
      postLogoutRedirectUri: appConfig.config?.ssoConfig?.postLogoutRedirectUri,
      clientId: appConfig.config?.ssoConfig?.clientId,
      responseType: 'code', // recommended for modern apps (PKCE)
      scope: 'openid profile email',
      strictDiscoveryDocumentValidation: false, // set to true in production
      showDebugInformation: true,
      requireHttps: false,
      requestAccessToken: true,
      dummyClientSecret: appConfig.config?.ssoConfig?.clientSecret,
      customParamsAuthRequest: {
        prompt: appConfig.config?.ssoConfig?.customParamsAuthRequestPrompt,
      },
    };
    // Now safe to initialize OAuthService
    await oauthService.configure(authConfig);
    await oauthService.loadDiscoveryDocumentAndTryLogin();
    if (appConfig.config?.ssoConfig?.enableSilentRefresh) {
      // oauthService.setupAutomaticSilentRefresh();
      oauthService.setupAutomaticSilentRefresh({}, 'access_token');
    }
    oauthService.events.subscribe(e => {
      console.log("OAuth event:", e.type, new Date());
      console.log("Access token expires in:", (oauthService.getAccessTokenExpiration() - Date.now()) / 1000, "seconds");
      console.log("ID token expires in:", (oauthService.getIdTokenExpiration() - Date.now()) / 1000, "seconds");
    });
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  var timestamp = new Date().getTime();
  return new TranslateHttpLoader(http, './assets/i18n/', '.json' + '?t=' + timestamp);
}
@NgModule({
  declarations: [
    AppComponent,
    UsersComponent,
    ConfirmDialogComponent,
    ConfigurationComponent,
    CustomSnackbarComponent,
    ImageZoomDialogComponent,
    IndvFolderComponent,
    FolderDetailDialogComponent,
    UploadDialogComponent,
    WebViewerFrameComponent,
  ],

  imports: [
    SharedModule,
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    AuthModule,
    AppMaterialModule,
    BrowserAnimationsModule,
    MainBoardModule,
    UploadListModule,
    LazyLoadImageModule,
    MatButtonToggleModule,
    ScrollingModule,
    ChangePasswordModule,
    NgxDropzoneModule,
    BackButtonDisableModule.forRoot({
      preserveScroll: true
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    OAuthModule.forRoot()
  ],
  providers: [AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    }, {
      provide: APP_INITIALIZER,
      useFactory: oauthInitializerFn,
      multi: true,
      deps: [OAuthService, AppConfigService]
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    IconService],
  bootstrap: [AppComponent]
})
export class AppModule { }

// export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader { return new TranslateHttpLoader(http); }